import React, { useEffect, useState } from "react";
import { getDronesParts } from "../../services/DroneServices";
import { Link, useNavigate } from "react-router-dom";

const SingularProduct = () => {
  const [allDroneParts, setAllDroneParts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    fetchDroneParts();
  }, [page]);
  const handleLoadMore = () => {
    setPage(page + 1); // Optional: update page number in state
    navigate(`/drone-parts?page=${page + 1}`); // Navigate with query param
  };
  const fetchDroneParts = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getDronesParts({ limit: 12, page, search: "" });
      if (response.status === "success") {
        setAllDroneParts((prevAllDroneParts) => [
          ...prevAllDroneParts,
          ...response.data.droneParts,
        ]);
        if (response.data.totalPages != 0) {
          setTotalPage(response.data.totalPages);
        }
      } else {
        setError("Failed to fetch drone parts");
      }
    } catch (error) {
      setError("An error occurred while fetching drone parts");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="py-5 ">
      <div className="container">
        {allDroneParts.length != 0 ? (
          <h4 className="ff_inter fs_26 fw-semibold">Related Product</h4>
        ) : null}

        <div className="row pb-md-4">
  {allDroneParts
    .filter((item) => !item?.title?.toLowerCase().includes("plan")) // exclude "plan"
    .map((item, index) => (
      <div
        key={index}
        className="col-lg-3 cursor_pointer col-sm-6 col-md-4 mt-4 col-12"
      >
        <Link to={`/drone-part-details/${item._id}`}>
          <div className="border d-flex flex-column justify-content-between border-1 h-100 rounded-3">
            <div>
              <img
                height={200}
                className="mx-auto w-100 object-fit-contain w_xsm_full rounded-3"
                src={item.images[0]}
                alt="drone image"
              />
              <p className="px-3 mt-3 fs_15 fw-bold ff_inter color_darkgray mb-0 mt-3">
                {item?.title.split("").slice(0, 50).join("")}...
              </p>
            </div>
            <div className="mt-3 px-3">
              <div className="mt-3 d-flex justify-content-between mb-3 align-items-center">
                <div className="d-flex flex-column">
                  <span className="fs_15 fw-bold ff_inter color_darkgray mb-0">
                    {/* Rs. {item.discountPrice} */}
                    {/* Rs. {new Intl.NumberFormat('en-IN').format(item.discountPrice)} */}
                  </span>
                  <span className=" fs_15 ff_inter">
                    Rs. {new Intl.NumberFormat("en-IN").format(item.price)}
                  </span>
                </div>
                <div>
                  <button className="viewall_btn bg_light_blue px-4 py-2 fs_17 fw-medium ff_inter text-white text-nowrap">
                    Buy Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    ))}

  {loading && (
    <div className="d-flex justify-content-center">
      <p>Loading...</p>
    </div>
  )}

  {error && (
    <div className="d-flex justify-content-center">
      <p className="text-danger">{error}</p>
    </div>
  )}

  {page !== totalPage && (
    <div className="d-flex justify-content-center">
      <button
        onClick={handleLoadMore}
        className="tab_btn px-4 py-2 border-0 rounded-2 mt-5 fs_13 ff_inter fw-semibold text-white"
      >
        Load More
      </button>
    </div>
  )}
</div>

      </div>
    </div>
  );
};

export default SingularProduct;
